module.exports = __webpack_public_path__ + "img/ordering-inactive.0330cf79.svg";